import type { ImpactMotionRefs } from './useImpactMotion';

type RadarDecorationProps = Pick<ImpactMotionRefs, 'radarRef' | 'counterSpinRefs'>;

const ORBITS = [
  'absolute top-0 left-1/2 -translate-x-1/2',
  'absolute bottom-0 left-1/2 -translate-x-1/2',
  'absolute top-1/2 left-0 -translate-y-1/2',
  'absolute top-1/2 right-0 -translate-y-1/2'
] as const;

function PersonMark({ size }: { size: 'lg' | 'sm' }) {
  const isLarge = size === 'lg';

  return (
    <div
      className={`flex flex-col items-center text-(--uizz-antd-color-white) ${isLarge ? 'w-18' : 'w-9'}`}
      aria-hidden='true'
    >
      <div className={isLarge ? 'size-8 rounded-full bg-current' : 'size-4 rounded-full bg-current'} />
      <div
        className={
          isLarge
            ? 'mt-2 h-6.5 w-14.75 rounded-t-[30px] rounded-b-md bg-current'
            : 'mt-1 h-3 w-7.5 rounded-t-[15px] rounded-b-sm bg-current'
        }
      />
    </div>
  );
}

function RadarDecoration({ radarRef, counterSpinRefs }: RadarDecorationProps) {
  return (
    <div className='pointer-events-none relative lg:flex-1 lg:self-stretch'>
      <div className='absolute top-[calc(50%+20px)] left-1/2 -translate-1/2 opacity-30'>
        <div className='relative flex size-60 items-center justify-center' aria-hidden='true'>
          <div className='absolute inset-0 rounded-full border-2 border-dotted border-(--uizz-antd-color-white)' />
          <div className='absolute inset-11.5 rounded-full border-2 border-dotted border-(--uizz-antd-color-white)' />
          <PersonMark size='lg' />
          <div ref={radarRef} className='absolute inset-0'>
            {ORBITS.map((className, index) => (
              <div key={`impact-radar-orbit-${index}`} className={className}>
                <div
                  ref={node => {
                    counterSpinRefs.current[index] = node;
                  }}
                >
                  <PersonMark size='sm' />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RadarDecoration;
